var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"126":1,"427":1,"495":1,"605":1,"620":1,"835":1,"906":1,"1014":1,"1304":1,"1413":1,"1539":1,"1676":1,"1968":1,"1979":1,"2086":1,"2577":1,"2608":1,"3191":1,"3427":1,"3648":1,"3677":1,"3687":1,"3734":1,"3972":1,"4084":1,"4303":1,"4431":1,"4535":1,"4656":1,"4749":1,"5042":1,"5058":1,"5112":1,"5115":1,"5409":1,"5686":1,"5890":1,"6038":1,"6142":1,"6236":1,"6255":1,"6300":1,"6352":1,"6389":1,"6596":1,"6792":1,"6830":1,"6957":1,"6986":1,"7092":1,"7152":1,"7203":1,"7220":1,"7263":1,"7265":1,"7289":1,"7464":1,"7495":1,"7541":1,"7704":1,"7974":1,"8003":1,"8162":1,"8202":1,"8390":1,"8421":1,"8423":1,"8609":1,"8713":1,"8837":1,"8851":1,"8913":1,"8938":1,"8949":1,"9015":1,"9265":1,"9467":1,"9483":1,"9580":1,"9581":1,"9626":1,"9799":1,"9861":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr